var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.detail.paymentRecordBoList && _vm.detail.paymentRecordBoList.length > 1
      ? _c("div", { staticClass: "pad20 pay" }, [
          _c("div", { staticClass: "flex" }, [
            _c("div", { staticClass: "gray3 f16 fb" }, [_vm._v("支付信息")]),
            _c("div", { staticClass: "flex-auto text-right mar15-b" }, [
              _vm._v("\n        已支付"),
              _c("span", { staticClass: "pad5-lr red" }, [
                _vm._v(
                  _vm._s(
                    _vm.detail.paymentRecordBoList
                      ? _vm.detail.paymentRecordBoList.length
                      : 0
                  )
                )
              ]),
              _vm._v("笔， 共计"),
              _c("span", { staticClass: "pad5-lr red" }, [
                _vm._v("¥ " + _vm._s(_vm.detail.pmoney))
              ]),
              _vm._v("，剩余待支付金额"),
              _c("span", { staticClass: "pad5-lr red" }, [
                _vm._v(
                  "¥ " +
                    _vm._s((_vm.detail.fmoney - _vm.detail.pmoney).toFixed(2))
                )
              ])
            ])
          ]),
          _c(
            "div",
            { staticClass: "flex" },
            _vm._l(_vm.detail.paymentRecordBoList, function(payment) {
              return _c(
                "div",
                { key: payment.paymentTime, staticClass: "w270" },
                [
                  _c("div", [_vm._v("¥ " + _vm._s(payment.pmoney))]),
                  _c("div", { staticClass: "f12 gray6" }, [
                    _vm._v(_vm._s(payment.paymentTime))
                  ])
                ]
              )
            }),
            0
          )
        ])
      : _vm._e(),
    _c("div", { staticClass: "pad20 flex text-right" }, [
      _c(
        "div",
        { staticClass: "text-right gray6 flex-auto mar15-r" },
        [
          _vm.detail.omoney > 0
            ? _c("div", { staticClass: "mar5-b" }, [_vm._v("货品总额：")])
            : _vm._e(),
          _vm.detail.smoney > 0
            ? _c("div", { staticClass: "mar5-b" }, [_vm._v("价格优惠：")])
            : _vm._e(),
          _vm.detail.couponMoney > 0
            ? _c("div", { staticClass: "mar5-b" }, [_vm._v("优惠券抵扣：")])
            : _vm._e(),
          _vm.detail.cashMoney > 0
            ? _c("div", { staticClass: "mar5-b" }, [_vm._v("现金券抵扣：")])
            : _vm._e(),
          _vm.detail.platformMoney > 0
            ? _c("div", { staticClass: "mar5-b" }, [_vm._v("平台券抵扣：")])
            : _vm._e(),
          _vm._l(_vm.detail.zkRecord, function(zk) {
            return _c("div", { key: zk.payTool, staticClass: "mar5-b" }, [
              zk.payTool == "SC_POINTS" && zk.amount > 0
                ? _c("div", [_vm._v("积分抵扣：")])
                : _vm._e(),
              zk.payTool == "BOUNTY_MONEY" && zk.amount > 0
                ? _c("div", [_vm._v("奖励金抵扣：")])
                : _vm._e()
            ])
          }),
          _c("div", { staticClass: "mar5-b" }, [_vm._v("运费：")]),
          _vm.detail.freightPromotionAmount &&
          Number(_vm.detail.freightPromotionAmount) > 0
            ? _c("div", { staticClass: "mar5-b" }, [
                _vm._v("新用户首单运费优惠：")
              ])
            : _vm._e(),
          _vm.detail.differenceMoney > 0
            ? _c("div", [_vm._v("返还金额：")])
            : _vm._e()
        ],
        2
      ),
      _c(
        "div",
        [
          _vm.detail.omoney > 0
            ? _c("div", { staticClass: "mar5-b" }, [
                _vm._v(
                  "¥" +
                    _vm._s(
                      _vm.detail.omoney
                        ? parseFloat(_vm.detail.omoney.toString()).toFixed(2)
                        : "0.00"
                    )
                )
              ])
            : _vm._e(),
          _vm.detail.smoney > 0
            ? _c("div", { staticClass: "mar5-b red" }, [
                _vm._v(
                  "- ¥" +
                    _vm._s(
                      _vm.detail.smoney
                        ? parseFloat(_vm.detail.smoney.toString()).toFixed(2)
                        : "0.00"
                    )
                )
              ])
            : _vm._e(),
          _vm.detail.couponMoney > 0
            ? _c("div", { staticClass: "mar5-b red" }, [
                _vm._v(
                  "- ¥" +
                    _vm._s(
                      _vm.detail.couponMoney
                        ? parseFloat(_vm.detail.couponMoney.toString()).toFixed(
                            2
                          )
                        : "0.00"
                    )
                )
              ])
            : _vm._e(),
          _vm.detail.cashMoney > 0
            ? _c("div", { staticClass: "mar5-b red" }, [
                _vm._v(
                  "- ¥" +
                    _vm._s(
                      _vm.detail.cashMoney
                        ? parseFloat(_vm.detail.cashMoney.toString()).toFixed(2)
                        : "0.00"
                    )
                )
              ])
            : _vm._e(),
          _vm.detail.platformMoney > 0
            ? _c("div", { staticClass: "mar5-b red" }, [
                _vm._v(
                  "\n        - ¥" +
                    _vm._s(
                      _vm.detail.platformMoney
                        ? parseFloat(
                            _vm.detail.platformMoney.toString()
                          ).toFixed(2)
                        : "0.00"
                    ) +
                    "\n      "
                )
              ])
            : _vm._e(),
          _vm._l(_vm.detail.zkRecord, function(zk) {
            return _c("div", { key: zk.payTool, staticClass: "mar5-b red" }, [
              zk.payTool == "SC_POINTS" && zk.amount > 0
                ? _c("div", [
                    _vm._v(
                      "- ¥" +
                        _vm._s(
                          zk.amount
                            ? parseFloat(zk.amount.toString()).toFixed(2)
                            : "0.00"
                        )
                    )
                  ])
                : _vm._e(),
              zk.payTool == "BOUNTY_MONEY" && zk.amount > 0
                ? _c("div", [
                    _vm._v(
                      "- ¥" +
                        _vm._s(
                          zk.amount
                            ? parseFloat(zk.amount.toString()).toFixed(2)
                            : "0.00"
                        )
                    )
                  ])
                : _vm._e()
            ])
          }),
          _c("div", { staticClass: "mar5-b" }, [
            _vm._v(
              "+ ¥" +
                _vm._s(
                  _vm.detail.freightMoney
                    ? parseFloat(_vm.detail.freightMoney.toString()).toFixed(2)
                    : "0.00"
                )
            )
          ]),
          _vm.detail.freightPromotionAmount &&
          Number(_vm.detail.freightPromotionAmount) > 0
            ? _c("div", { staticClass: "mar5-b" }, [
                _vm._v(
                  "\n        - ¥" +
                    _vm._s(
                      _vm.detail.freightPromotionAmount
                        ? parseFloat(
                            _vm.detail.freightPromotionAmount.toString()
                          ).toFixed(2)
                        : "0.00"
                    ) +
                    "\n      "
                )
              ])
            : _vm._e(),
          _vm.detail.differenceMoney > 0
            ? _c("div", { staticClass: "red" }, [
                _vm._v(
                  "\n        ¥" +
                    _vm._s(
                      _vm.detail.differenceMoney
                        ? parseFloat(
                            _vm.detail.differenceMoney.toString()
                          ).toFixed(2)
                        : "0.00"
                    ) +
                    "\n      "
                )
              ])
            : _vm._e()
        ],
        2
      )
    ]),
    _c(
      "div",
      {
        staticClass:
          "pad20 mar15-t flex items-baseline justify-end pad5-t pad5-b total"
      },
      [
        _c("div", { staticClass: "gray6 mar10-r" }, [_vm._v("应付款")]),
        _c("div", { staticClass: "red mar5-r" }, [_vm._v("¥")]),
        _c("div", { staticClass: "red f28" }, [
          _vm._v(
            _vm._s(
              _vm.detail.fmoney
                ? _vm.detail.fmoney.toString().split(".")[0]
                : _vm.detail.fmoney || "0.00"
            )
          )
        ]),
        _c("div", { staticClass: "red" }, [
          _vm._v(
            "." +
              _vm._s(
                _vm.detail.fmoney &&
                  _vm.detail.fmoney.toString().split(".").length > 1
                  ? _vm.detail.fmoney.toFixed(2).split(".")[1]
                  : "00"
              )
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }